import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "modal_refund_confirmation",
  ref: "refundConfirmationRef",
  "aria-hidden": "true",
  class: "modal fade",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-600px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = {
  id: "kt_modal_refund_confirmation_header",
  class: "modal-header"
}
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = { class: "fw-bolder" }
const _hoisted_7 = {
  class: "btn btn-icon btn-sm btn-active-icon-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "modal-body py-10 px-lg-10" }
const _hoisted_10 = { class: "notice d-flex bg-light-primary rounded border-primary border border-dashed p-6 mb-5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-circle fs-2tx text-primary" }, null, -1)
const _hoisted_12 = { class: "d-flex flex-stack flex-grow-1" }
const _hoisted_13 = { class: "fs-6 text-gray-800 ps-5" }
const _hoisted_14 = { class: "d-flex flex-column flex-grow-1 pe-8 mb-5" }
const _hoisted_15 = { class: "d-flex flex-wrap" }
const _hoisted_16 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_17 = { class: "d-flex align-items-center" }
const _hoisted_18 = { class: "fs-2 fw-bold counted" }
const _hoisted_19 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_20 = {
  key: 1,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "fs-2 fw-bold counted" }
const _hoisted_23 = { class: "fw-semibold fs-6 text-gray-400" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "form-group mb-7" }
const _hoisted_26 = { class: "fs-6 fw-bold mb-2 required" }
const _hoisted_27 = { class: "modal-footer justify-content-end gap-2" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "svg-icon svg-icon-3" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { class: "svg-icon svg-icon-3" }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.$t("refundProcessing.modal.refundConfirmation")), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.formData,
          rules: _ctx.rules
        }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("refundProcessing.modal.confirmTip")), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.salesOrderNo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.salesOrderNo), 1)
                        ]),
                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("refundProcessing.modal.orderNo")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.refundAmount)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, _toDisplayString((_ctx.refundCurrency == "EUR" ? "€ " : "¥ ") +
                        _ctx.$currency.currency(_ctx.refundAmount, 2, ",", ".", "")), 1)
                        ]),
                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("refundProcessing.information.refundAmount")), 1)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("refundProcessing.modal.accountPassword")) + ":", 1),
                  _createVNode(_component_el_form_item, { prop: "password" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.formData.password,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.password) = $event)),
                        type: "password",
                        placeholder: _ctx.t('common.plsEnter'),
                        clearable: ""
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-light",
                disabled: _ctx.loading,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.modalHide && _ctx.modalHide(...args)))
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                      _createElementVNode("span", _hoisted_30, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.cancel")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_31, [
                      _hoisted_32,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                    ]))
              ], 8, _hoisted_28),
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-lg btn-primary",
                disabled: _ctx.loading,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
              }, [
                (!_ctx.loading)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                      _createElementVNode("span", _hoisted_35, [
                        _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
                      ]),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.submit")), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_36, [
                      _hoisted_37,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("common.pleaseWait")), 1)
                    ]))
              ], 8, _hoisted_33)
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ], 512))
}